module.exports = __webpack_public_path__ + "static/media/cds_terms.87d666ba.htm";